const checkTitleSize = () => {
    if (document.querySelector('.ume-career-title-check-size')) {
        const title = document.querySelector('.ume-career-title-check-size');

        if (Array.from(title.innerText.replace(/(\&shy;|­|&#173;)/gi, "")).length > 60) {
            let factor = 0.8;
            if (Array.from(title.innerText.replace(/(\&shy;|­|&#173;)/gi, "")).length > 80) factor = 0.6;
            let styling = getComputedStyle(title);

            let fontSize = styling.fontSize;
            let newFontSize = factor * parseInt(fontSize);
            title.setAttribute('style', `font-size: ${Math.floor(newFontSize) > 24 ? Math.floor(newFontSize) : 24}px`);
        }
    }
}
export default checkTitleSize;